import supportedLocales from "../translations/supported-locales.json";

export const publicSiteConfig = {
  companyName: "METAL ASIA",
  contactEmail: "info@metal-asia.com",
  contactEmailHref: "mailto:info@metal-asia.com",
  contactPhone: "+7 777 690 48 57",
  contactPhoneHref: "tel:+77776904857",
  contactWhatsappHref: "https://wa.me/77776904857",
  socialLinks: [
    {
      id: "linkedin",
      label: "LinkedIn",
      href: "https://www.linkedin.com/company/metal-asia/",
      mark: "in",
    },
    {
      id: "instagram",
      label: "Instagram",
      href: "https://www.instagram.com/metal_asia/",
      mark: "◎",
    },
    {
      id: "facebook",
      label: "Facebook",
      href: "https://www.facebook.com/profile.php?id=61594664442258",
      mark: "f",
    },
  ],
  defaultLocale: "en",
  supportedLocales: Object.keys(supportedLocales) as (keyof typeof supportedLocales)[],
  languagePreferenceKey: "metal-asia-language",
  legacyLanguagePreferenceKey: "vertexmetall-language",
} as const;
